import { LEGACY_WEB_INTERFACE } from 'src/modules/constants';
import { Module, ModulesList } from 'src/modules/types';
import LegacyWebInterface from './index';

const module: ModulesList = {
  [LEGACY_WEB_INTERFACE]: {
    path: '/web2/*',
    component: LegacyWebInterface,
  } as Module,
};

export default module;
